import * as types from "../actions/ActionTypes.js";

export const getInitialState = () => (
    {
        virtualProduct: null,
        linkedSites: [],
        products: [],
        virtualProducts: []
    });

const productReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_VIRTUAL_PRODUCT_BY_ID_SUCCEEDED:
        return Object.assign({}, state, { virtualProduct: action.virtualProduct });
    
    case types.GET_VIRTUAL_PRODUCTS_SUCCEEDED:
        return Object.assign({}, state, { virtualProducts: action.virtualProducts });

    case types.GET_LINKED_USERS_SUCCEEDED: {
        const linkedSites = getLinkedSites(action.users);
        return Object.assign({}, state, { linkedSites: linkedSites });
    }
    default:
        return state;
    }
};

const getLinkedSites = (users) => {
    return users.map((s) => ({
        value: s.id.toString(),
        label: s.site + " - " + s.siteName
    }))
        .sort((a, b) => a.label - b.label);
};

export default productReducer;
